import { useEffect, useState } from 'react'

/** Opóźnia aktualizację wartości — dzięki temu wpisywanie w wyszukiwarkę
 *  nie wysyła zapytania po każdym znaku. */
export function useDebouncedValue<T>(value: T, delayMs = 350): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const timer = window.setTimeout(() => setDebounced(value), delayMs)
    return () => window.clearTimeout(timer)
  }, [value, delayMs])

  return debounced
}
